/* SCC PageFly/Appstle variant bridge - staging test */
(function () {
  var TARGET_HANDLES = ["upper-and-lower-retainers-set", "night-guard"];
  var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
  var handle = match && match[1];
  if (TARGET_HANDLES.indexOf(handle) === -1) return;
  if (window.SCCPageflyAppstleVariantBridge) return;

  var productData = null;
  var productId = "";
  var timer = null;

  function normalize(value) {
    return (value || "").toString().trim().toLowerCase().replace(/\s+/g, " ");
  }

  function money(cents) {
    return "$" + (Number(cents || 0) / 100).toFixed(2);
  }

  function getSelectedValues() {
    var values = [];
    document.querySelectorAll(".pf-variant-select").forEach(function (select) {
      var selected = select.options && select.options[select.selectedIndex] ? select.options[select.selectedIndex] : null;
      var value = (selected && (selected.value || selected.text) || select.value || "").toString().trim();
      if (value) values.push(value);
    });
    return values;
  }

  function getEmbeddedProductData() {
    var element = document.querySelector(".appstle_stand_alone_selector");
    if (!element) return null;
    var raw = element.getAttribute("data-product-data");
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (_) {
      return null;
    }
  }

  async function getProductData() {
    if (productData) return productData;
    productData = getEmbeddedProductData();
    if (!productData) {
      var response = await fetch("/products/" + handle + ".js");
      if (!response.ok) throw new Error("Unable to load product JSON for " + handle);
      productData = await response.json();
    }
    productId = String(productData.id || "");
    return productData;
  }

  function variantOptions(variant) {
    return (variant.options && variant.options.length ? variant.options : [variant.option1, variant.option2, variant.option3].filter(Boolean));
  }

  function findSelectedVariant(product) {
    var selected = getSelectedValues().map(normalize);
    if (!selected.length) return null;
    return (product.variants || []).find(function (variant) {
      var options = variantOptions(variant).map(normalize);
      return selected.every(function (value, index) {
        return options[index] === value;
      });
    }) || (product.variants || []).find(function (variant) {
      var title = normalize(variant.title);
      return selected.every(function (value) {
        return title.indexOf(value) !== -1;
      });
    }) || null;
  }

  function setText(selector, value) {
    if (!value) return;
    document.querySelectorAll(selector).forEach(function (element) {
      if ((element.textContent || "").trim() !== value) element.textContent = value;
    });
  }

  function dispatchChanged(element) {
    try {
      element.dispatchEvent(new Event("input", { bubbles: true }));
      element.dispatchEvent(new Event("change", { bubbles: true }));
    } catch (_) {}
  }

  function updateHiddenVariant(variant) {
    var id = String(variant.id);
    document.querySelectorAll('[data-pf-type="ProductVariantSwatches"][data-product-id="' + productId + '"] input[name="id"], form[action*="/cart/add"] input[name="id"], input[name="id"][data-product-id="' + productId + '"]').forEach(function (input) {
      if (String(input.value) !== id) {
        input.value = id;
        input.setAttribute("value", id);
        dispatchChanged(input);
      }
    });
  }

  function updateUrl(variant) {
    try {
      var url = new URL(window.location.href);
      if (url.searchParams.get("variant") !== String(variant.id)) {
        url.searchParams.set("variant", String(variant.id));
        window.history.replaceState(window.history.state, "", url.toString());
      }
    } catch (_) {}
  }

  function updatePageflyPrice(variant) {
    setText('[data-product-type="price"][data-product-id="' + productId + '"], [data-product-price][data-product-id="' + productId + '"]', money(variant.price));
    if (variant.compare_at_price) {
      setText('[data-product-type="compare_at_price"][data-product-id="' + productId + '"]', money(variant.compare_at_price));
    }
  }

  function updatePageflyState(variant) {
    if (!window.__pageflyProducts) window.__pageflyProducts = {};
    if (!window.__pageflyProducts[productId]) window.__pageflyProducts[productId] = {};
    window.__pageflyProducts[productId].selected_variant = variant;
    window.__pageflyProducts[productId].selected_or_first_available_variant = variant;
  }

  function updateAppstle(variant) {
    var allocation = (variant.selling_plan_allocations || [])[0];
    document.querySelectorAll('input[name="selling_plan"]').forEach(function (input) {
      if (!String(input.value || "").trim() || !allocation) return;
      input.value = String(allocation.selling_plan_id);
      input.setAttribute("value", String(allocation.selling_plan_id));
      dispatchChanged(input);
    });

    if (allocation) {
      setText(".appstle_subscription_radio_wrapper .appstle_subscription_amount, .appstle_subscription_amount_wrapper .appstle_subscription_amount", money(allocation.price));
      setText(".appstle_subscription_compare_amount", money(allocation.compare_at_price || variant.price));
    }

    setText(".appstle_one_time_price_wrapper .appstle_subscription_amount, .appstle_one_time_amount, .appstle_onetime_amount", money(variant.price));
    if (variant.compare_at_price) {
      setText(".appstle_subscription_amount_compare_at_price, .appstle_one_time_compare_amount, .appstle_onetime_amount_compare", money(variant.compare_at_price));
    }
  }

  async function applySelectedVariant() {
    var product = await getProductData();
    var variant = findSelectedVariant(product);
    if (!variant) return null;
    updateHiddenVariant(variant);
    updateUrl(variant);
    updatePageflyPrice(variant);
    updatePageflyState(variant);
    updateAppstle(variant);
    return variant;
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(applySelectedVariant, 80);
  }

  document.addEventListener("change", function (event) {
    if (event.target && event.target.matches && event.target.matches(".pf-variant-select")) schedule();
  }, true);
  document.addEventListener("input", function (event) {
    if (event.target && event.target.matches && event.target.matches(".pf-variant-select")) schedule();
  }, true);
  document.addEventListener("pagefly:afterRender", schedule);
  document.addEventListener("DOMContentLoaded", schedule);
  if (document.readyState !== "loading") schedule();

  window.SCCPageflyAppstleVariantBridge = {
    applySelectedVariant: applySelectedVariant,
    findSelectedVariant: function () {
      return productData ? findSelectedVariant(productData) : null;
    },
  };
})();
